import React from 'react';
import styles from './Form.module.scss';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef?: any;
  error?: any;
}

export default function FormInput({ inputRef, error, ...props }: Props) {
  return (
    <div
      className={`${styles.formInput} ${error ? styles.formInputError : ''}`}
    >
      <input ref={inputRef} {...props} />
      {error && <p className={styles.labelError}>{error}</p>}
    </div>
  );
}
